import request from "./request";

//广告模板
export const getCreator = (data) => request("/report/getCreator", data, "GET");
export const queryAdTemplate = (data) => request("/report/queryAdTemplate", data, "GET");
export const deleteAdTemplate = (data) => request("/report/deleteAdTemplate", data, "POST");

/* 广点通 */
// 获取广告模板
export const getAdTemplateList_gdt = (data) => request("/adTemplate/list", data, "GET");
// 获取创建人列表
export const getAdCreatorList_gdt = (data) => request("/adTemplate/creators", data, "GET");
// 删除广告模板
export const deleteAdTemplate_gdt = (data) => request("/adTemplate/delete", data, "GET");

/* 事件管理 */
// 查询所有的资产列表
export const getAllAssets_tt = (data) => request("/property/getAllAssets", data, "GET");
// 同步事件管理数据
export const refreshAssets_tt = (data) => request("/property/assets", data, "GET");
// 同步事件管理数据
export const getEvents_tt = (data) => request("/property/getEvents", data, "GET");
// 获取资产下的监控链接组
export const getTruckUrl_tt = (data) => request("/toutiao/getTruckUrl", data, "GET");
// 在已有资产事件下创建检测链接
export const createTrack_tt = (data) => request("/property/createTrack", data, "POST_JSON");
